
    <section class="interest-section">
        <h2>Ce qui va vous intéresser</h2>
        <div class="button-group">
            <a href="/avis/" class="btn">Avis</a>
            <a href="/contact/" class="btn">Contact</a>
            <a href="/faq/" class="btn">FAQ</a>
        </div>
    </section>
